{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Lösenord",
      "PLACEHOLDER": "Lösenord",
      "ERROR": "Lösenordet är för kort."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Bekräfta lösenord",
      "ERROR": "Lösenorden matchar inte."
    },
    "API": {
      "SUCCESS_MESSAGE": "Lösenordet ändrat.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "Skicka"
  }
}
